<div class="s-auth">
  <div class="s-auth__wrapper">
    <div class="s-auth__imagen"></div>
    <div class="s-auth__container">
      <div class="s-auth__contenido">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
